import Quill from 'quill';
import { Delta } from 'quill';
import { BadgeType } from '@sml/badge'
import { ITEM_TYPE_ENUM } from '../enums/item-status-type.enum';

export interface MediaMetaData {
  file: File;
  location: string;
}

export interface PopupState {
  openPopup: boolean;
  location: string;
}

export interface IDictionary<K, V> {
  [key: string]: V[];
}

export interface Card {
  imageSrc: string;
  heading: string;
  subHeading: string;
  typeId: number;
  typeName: string;
  registrationSubType?: number | null; // RegistrationCampaignSubTypeEnum value, only set for Registration
  gallerySrc:string;
}

export enum CampaignTypeEnum {
  'Memorial Program' = 3,
  'Volunteer Activity' = 5,
  'Sponsorship + Fundraiser' = 4,
  Other = 6,
}

export enum CampaignTypeEnumm {
  'Memorial Program' = 3,
  'Volunteer Activity' = 5,
  'Sponsorship' = 179,
  'Fundraiser' = 180,
  'Registration' = 181, 
  'Interactive Tour' = 182,
  'Ticketing'=190,
}

export enum RegistrationCampaignSubTypeEnum {
  'Vendor Registration' = 213,
  'Community Sign-Up' = 214,
}

// A Registration campaign's sub type decides which item type its items are created as.
export const REGISTRATION_SUB_TYPE_ITEM_TYPE: Record<RegistrationCampaignSubTypeEnum, ITEM_TYPE_ENUM> = {
  [RegistrationCampaignSubTypeEnum['Vendor Registration']]: ITEM_TYPE_ENUM['Vendor Registration'],
  [RegistrationCampaignSubTypeEnum['Community Sign-Up']]: ITEM_TYPE_ENUM['Community Sign-Ups'],
};

export function getRegistrationItemType(registrationSubType?: number | null): ITEM_TYPE_ENUM {
  return REGISTRATION_SUB_TYPE_ITEM_TYPE[registrationSubType as RegistrationCampaignSubTypeEnum] ?? ITEM_TYPE_ENUM['Registration'];
}

export enum DateRangeEnum {
  'Exact Date' = 1,
  'Date Range' = 2,
}

export function getCampaignTypeName(id: number | null): string  {
  return id ? CampaignTypeEnumm[id] : '';
}

export function getCampaignTypeDisplayName(id: number | null, registrationSubType?: number | null): string {
  if (id === CampaignTypeEnumm['Registration'] && registrationSubType) {
    return RegistrationCampaignSubTypeEnum[registrationSubType] ?? getCampaignTypeName(id);
  }
  return getCampaignTypeName(id);
}

export enum CampaignAccessLevelEnum {
  ['Public'] = 186,
  ['Private'] = 187,
  ['Archived'] = 188
}

export enum VisibilityEnum {
  Private = 'private',
  Public = 'public',
}
export enum TourStopEnum {
  Yes='Yes',
  No='No'
}
export enum CheckInStatus {
  CheckedIn = 1,
  NotCheckedIn = 0,
}

export enum CampaignStatusEnum {
  Active = 7,
  Complete = 8,
}

export interface QuillEditorEvent {
  content: Delta;
  delta: Delta;
  editor: Quill;
  html: string | null;
  oldDelta: Delta;
  source: string;
  text: string;
}

export interface ISelectedRange {
  startDate: Date | null;
  endDate: Date | null;
}

export interface TabItem {
  key: string;
  title: string;
  link?: string;
  callback?: any;
  icon?: string;
  mediaLength?: number;
  howToId?: string
}

export interface CampaignFormModel {
  campaignName: string;
  campaignStatus: number;
  campaignType: number | null;
  registrationSubType?: number | null; // RegistrationCampaignSubTypeEnum value, only set for Registration campaigns
  viewType: number;
  startDate: string;
  endDate: string;
  visibilityType: number; // CampaignAccessLevelEnum value
  aboutCampaign: string;
  guidelines: string;
  displayFundraisingBar?: boolean;
  goalAmount: number |null;
  isMapViewEnabled: boolean | null ;
  tourStopNumber?: boolean;
  address?: string;
  eventAddress?: string;
  latitude?: number;
  longitude?: number;
}
export interface CampaignSettingFormModel {
  displayCampaignsItems?: number;
  sortItemListing?: number;
  participationRecognition?: boolean;
  visibilityType?: number; // CampaignAccessLevelEnum value
  generateTaxReceipt?: boolean;
  tourStopNumber?:boolean;
  requireApplicantApproval?: boolean;
  isMaxTicketCapacityEnabled?: boolean;
  maxTicketCapacity?: number | null;
}

export interface BasicFormValidation {
  isValid: boolean;
  formData: CampaignFormModel;
}

export interface DescriptionFormModel {
  participate: string;
}

export interface DescriptionData {
  isValue: boolean;
  formData: DescriptionFormModel;
}

export interface CreateCampaignModel {
  campaignName: string | null;
  campaignStatus: number;
  campaignType: CampaignTypeEnum | null;
  viewType: number;
  startDate: string;
  endDate: string;
  visibilityType: string;
  isMapViewEnabled: boolean | null;
  tourStopNumber?: string;
}

export interface CreateCampaignValidation {
  isValid: boolean;
  form: CampaignFormModel;
}

export enum Step {
  BASIC_INFORMATION = 'Basic Information',
  DATES = 'Dates',
  DETAILS = 'Participation Details',
  PARTICIPATION = 'Participation Form',
  PRICING = 'Pricing',
  LOCATION = 'Location',
  UPLOADS = 'Uploads',
  DONATION = 'Donation + QR Plaque ',
}

export interface ISearchDropDownBadge {
  type?: BadgeType;
  label?: string;
  showIcon?: boolean;
}